module.exports = __webpack_public_path__ + "static/scale-model-of-tulsa-oklahoma-cf9e9682b1afc7e403249fc05bd6eb91.png";